var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SystemHead'),_c('div',{staticClass:"system-container"},[_c('Siderbar'),_c('div',{staticClass:"main-container"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }